import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl, FormArray } from '@angular/forms';
import { AdditionalInsured } from './AdditionalInsured.Model';
import { emptyModal } from '../DAO';
import { from } from 'rxjs';

export class AdditionalInsuredFormGroup extends UntypedFormGroup {
    readonly addInsuredInterestType = this.get('addInsuredInterestType') as UntypedFormControl;
    readonly addInsuredLoanNumber = this.get('addInsuredLoanNumber') as UntypedFormControl;
    readonly addInsuredName = this.get('addInsuredName') as UntypedFormControl;
    readonly lineOfBusiness = this.get('lineOfBusiness') as UntypedFormControl;
    readonly name = this.get('name') as UntypedFormControl;
    readonly street = this.get('street') as UntypedFormControl;
    readonly city = this.get('city') as UntypedFormControl;
    readonly postalCode = this.get('postalCode') as UntypedFormControl;
    readonly state = this.get('state') as UntypedFormControl;

    constructor(readonly addInsured: AdditionalInsured, readonly formBuilder: UntypedFormBuilder = new UntypedFormBuilder()) {
        super({
            addInsuredInterestType: new UntypedFormControl(addInsured.addInsuredInterestType?.answer, AdditionalInsuredFormGroup.getValidator(addInsured.addInsuredInterestType)),
            addInsuredLoanNumber: new UntypedFormControl(addInsured.addInsuredLoanNumber?.answer),
            addInsuredName: new UntypedFormControl(addInsured.addInsuredName?.answer, AdditionalInsuredFormGroup.getValidator(addInsured.addInsuredName)),
            lineOfBusiness: new UntypedFormControl(addInsured.lineOfBusiness, AdditionalInsuredFormGroup.getValidator(addInsured.name)),
            name: new UntypedFormControl(addInsured.name?.answer, AdditionalInsuredFormGroup.getValidator(addInsured.name)),
            street: new UntypedFormControl(addInsured.address.street, Validators.required),
            city: new UntypedFormControl(addInsured.address.city, Validators.required),
            postalCode: new UntypedFormControl(addInsured.address.postalCode, Validators.required),
            state: new UntypedFormControl(addInsured.address.state, Validators.required),
        });

        this.subscribeToValueChanges();
    }

    static getValidator(control: emptyModal) {
        if (control.required) {
            return Validators.required;
        }
        return null;
    }

    private subscribeToValueChanges() {

        this.addInsuredInterestType.valueChanges.subscribe((value: string) => {
            this.addInsured.addInsuredInterestType.answer = value;
        });

        this.addInsuredName.valueChanges.subscribe((value: string) => {
            this.addInsured.addInsuredName.answer = value;
        });

        this.addInsuredLoanNumber.valueChanges.subscribe((value: string) => {
            this.addInsured.addInsuredLoanNumber.answer = value;
        });

        this.lineOfBusiness.valueChanges.subscribe((value: any) => {
            this.addInsured.lineOfBusiness = value;
        });

        this.name.valueChanges.subscribe((value: string) => {
            this.addInsured.name.answer = value;
        });

        this.city.valueChanges.subscribe((value: string) => {
            this.addInsured.address.city = value;
        });

        this.state.valueChanges.subscribe((value: string) => {
            this.addInsured.address.state = value;
        });

        this.street.valueChanges.subscribe((value: string) => {
            this.addInsured.address.street = value;
        });

        this.postalCode.valueChanges.subscribe((value: string) => {
            this.addInsured.address.postalCode = value;
        });
    }
}